import {
  TOGGLE_SIDE_MENU,
  OPEN_SIDE_MENU,
  CLOSE_SIDE_MENU,
} from '../actions/constants';
import controlMap from '../components/pages/Play/controlTypes';

const controlTypes = Object.keys(controlMap);

const getDefaultState = () => {
  return {
    sideMenuOpen: false,
  };
};

const defaultState = getDefaultState();

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case TOGGLE_SIDE_MENU: {
      return {
        ...state,
        sideMenuOpen: !state.sideMenuOpen,
      };
    }

    case OPEN_SIDE_MENU: {
      return {
        ...state,
        sideMenuOpen: true,
      };
    }

    case CLOSE_SIDE_MENU: {
      return {
        ...state,
        sideMenuOpen: false,
      };
    }

    default: return state;
  }
}
